import React from 'react';
import { Layout, Menu, Typography, Button, theme } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import {
  DashboardOutlined, UnorderedListOutlined, ArrowDownOutlined,
  SaveOutlined, CreditCardOutlined, AimOutlined, FileTextOutlined,
  LogoutOutlined,
} from '@ant-design/icons';
import { IS_EMBEDDED } from '../config';
import { useAuth } from '../context/AuthContext';

const { Sider, Content, Header } = Layout;
const { Title } = Typography;

const NAV_ITEMS = [
  { key: '/', icon: <DashboardOutlined />, label: <Link to="/">Dashboard</Link> },
  { key: '/transactions', icon: <UnorderedListOutlined />, label: <Link to="/transactions">Transactions</Link> },
  { key: '/income', icon: <ArrowDownOutlined />, label: <Link to="/income">Income</Link> },
  { key: '/savings', icon: <SaveOutlined />, label: <Link to="/savings">Savings</Link> },
  { key: '/cards', icon: <CreditCardOutlined />, label: <Link to="/cards">Cards & Accounts</Link> },
  { key: '/budgets', icon: <AimOutlined />, label: <Link to="/budgets">Monthly Budgets</Link> },
  { key: '/reports', icon: <FileTextOutlined />, label: <Link to="/reports">Reports</Link> },
];

export default function AppLayout({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();
  const { logout } = useAuth();
  const { token: { colorBgContainer, colorPrimary } } = theme.useToken();

  if (IS_EMBEDDED) {
    // Embedded in platform iframe — no sidebar, just content
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <Content style={{ padding: 16, background: colorBgContainer }}>
          {children}
        </Content>
      </Layout>
    );
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider width={220} theme="light" style={{ borderRight: '1px solid #f0f0f0' }}>
        <div style={{ padding: '20px 16px 12px', borderBottom: '1px solid #f0f0f0' }}>
          <Title level={5} style={{ margin: 0, color: colorPrimary }}>
            💰 MyBudget
          </Title>
          <Typography.Text type="secondary" style={{ fontSize: 11 }}>
            UrbanLife.Works
          </Typography.Text>
        </div>
        <Menu
          mode="inline"
          selectedKeys={[pathname]}
          items={NAV_ITEMS}
          style={{ border: 'none', flex: 1 }}
        />
        <div style={{ padding: 16, borderTop: '1px solid #f0f0f0' }}>
          <Button
            icon={<LogoutOutlined />}
            type="text"
            size="small"
            onClick={logout}
            style={{ width: '100%', textAlign: 'left' }}
          >
            Sign out
          </Button>
        </div>
      </Sider>
      <Layout>
        <Content style={{ padding: 24, background: colorBgContainer }}>
          {children}
        </Content>
      </Layout>
    </Layout>
  );
}
